import { render } from "./Help.vue?vue&type=template&id=5d33819e"
import script from "./Help.vue?vue&type=script&lang=ts"
export * from "./Help.vue?vue&type=script&lang=ts"

import "./Help.vue?vue&type=style&index=0&id=5d33819e&lang=css"
script.render = render

export default script